module.exports = __webpack_public_path__ + "static/media/blogpost2.af4c66ba.png";